import React, {useEffect} from 'react';
import DetailCard from './ui-components/detail-card';
import {sectionLayoutChildAnimation, sectionLayoutParentAnimation,} from '../utils/animations';
import {useInView} from 'react-intersection-observer';
import {motion, useAnimation} from 'framer-motion';

export default function Section2() {
    const controls = useAnimation();
    const {ref, inView} = useInView({threshold: 0.1, triggerOnce: true});

    useEffect(() => {
        if (inView) {
            controls.start('visible');
        }
        if (!inView) {
            controls.start('hidden');
        }
    }, [controls, inView]);

    const cards = [
        {
            title: 'AccuTerra Adapt',
            image: 'scenery_2',
            body:
                [
                    'Finding reliable information on trail accessibility can be a real headache. To truly feel safe and be ready to explore, hikers need clear answers to essential questions:' +
                    '<ul><li>Will my gear work on this trail?</li>' +
                    '<li>Anything that could be dangerous?</li>' +
                    '<li>Is there a bathroom anywhere?</li></ul>',
                    'That\'s where AccuTerra Adapt comes in. We\'ve developed a powerful digital trail assessment tool you can take anywhere. It\'s packed with features like augmented reality for measuring trail width, obstacles, cross-slope, and grade, all viewable on a clear, easy-to-use map.',
                    'Whether you\'re involved in trail assessments, helping visitors as a park ranger, or something similar, you can count on Adapt to help you share accessibility info and feedback with total confidence. Beyond that, we\'re adding the building blocks for a robust trail companion app to empower users. With this, hikers can preview measurements, navigate trails, save and share their experiences, and record their own trails.',
                    'We believe that making trails accessible for everyone means providing a tool that can adapt to many different needs and missions. So, if the options below aren\'t exactly what you\'re looking for, please reach out! We\'re eager to discuss how we can create a solution that works just for you.',
                ]
        },
    ];

    return (
        <div className="mb-16 border-b-2 border-gray-300">
            <motion.div
                ref={ref}
                initial="hidden"
                animate={controls}
                variants={sectionLayoutParentAnimation}
                className={`text-center   border-gray-200  `}
            >
                <motion.div
                    variants={sectionLayoutChildAnimation}
                    className="max-w-2xl mx-auto text-center"
                >
                </motion.div>

                <motion.div variants={sectionLayoutParentAnimation} className="mt-5">
                    {cards.map((card, idx) => (
                        <DetailCard
                            cardBackground={false}
                            key={idx}
                            title={card.title}
                            image={card.image}
                            body={card.body}
                            idx={!(idx % 2)}
                        />
                    ))}
                </motion.div>
            </motion.div>
        </div>
    );
}
